// extracted by mini-css-extract-plugin
export default {"cardBoxSty":"WorkshopUsage_cardBoxSty__wpioP","charts_wrapper":"WorkshopUsage_charts_wrapper__lyU8y"};